import { createApp } from 'vue'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'

import "./assets/styles.scss"
import "./assets/responsive.scss"

import PrimeVue from 'primevue/config';
import InputMask from 'primevue/inputmask';
import Button from 'primevue/button';
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueResizeText from "vue3-resize-text"

import Vue3Transitions from 'vue3-transitions'

// Configurações do axios
var _axios = axios.create({
    baseURL: process.env.VUE_APP_API,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }
});

const app = 
    createApp(App)
        .use(store)
        .use(router)
        .use(PrimeVue)

app.use(Vue3Transitions)
app.use(VueAxios, _axios)
app.provide('axios', _axios)
app.component('InputMask', InputMask);
app.component('Button', Button);
app.mount('#app')